import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property/property.service';
import { DevelopmentService } from '@app/_components/development/development.service';
import { PickList } from 'primeng/picklist';
import { CompendiumService } from '../compendium/compendium.service';
import { CompendiumShortTermRentalJoinService } from '../compendium-short-term-rental-join/compendiums-short-term-rental-join.service';
import { Compendium } from '../compendium/compendium';

@Component({
    selector: 'app-view-property-compendium',
    templateUrl: './property-view-compendium.component.html',
    styleUrls: ['./property-view-compendium.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ViewPropertyCompendiumComponent implements OnInit {

	@ViewChild('pickList') pickList: PickList;
		properties: any[]=[];
		developments: any[]=[];
	
		sourceProperties: any[]=[];
		targetProperties: any[]=[];
		compendiumShortTermRentalJoins: any[]=[];
		isDataLoaded = false;
		selectedFilter: string = "name";
		filters: any;
		compendiumObj: any[] = [];
		shortTermRentalIds: any[] = [];
		isSearching = false;
		targetPropertyLength: number;
		compendiums: any[]=[];
		targetCompendiums: any[] = [];
		sourceCompendiums: any[] = [];
		shortTermRentalId: any;
		compendiumIds: any[]=[];
	
		locationAreas: any[]=[];
	
		isCompendiumLoaded=false;
	  groupedData: { [key: string]: any[] };
	  groupingData: { [key: string]: any[]; };
	  orderByKey: (a: any, b: any) => number;
		compendiumShortTermRentalJoinsObj: any[]=[];
		hasGroupedData = false;
		locationAreaNameMap: { [key: string]: string } = {};
	
		constructor(
			private primengConfig: PrimeNGConfig,
			private renderer: Renderer2,
			private compendiumService: CompendiumService,
			private compendiumShortTermRentalJoinService: CompendiumShortTermRentalJoinService,
			private propertyService: PropertyService,
			private developmentService: DevelopmentService,
			private alertService: AlertService,
			private messageService: MessageService,
			private confirmationService: ConfirmationService,
			private formBuilder: UntypedFormBuilder,
			@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
				this.compendium = data.compendium,
				this.statuses = compendiumService.statuses;
				this.selectedFilter = "propertyCode";
				this.filters = compendiumService.filters;
				this.locationAreas = compendiumService.locationAreas;
		}
	
		@Input() compendium: Compendium;
		@Output() doAdd = new EventEmitter<any>();
		@Output() doUpdate = new EventEmitter<any>();
		@Output() doDelete = new EventEmitter<any>();
	
		// data
		compendiumId: number;
	
		// forms
		form1: UntypedFormGroup;
		formLoading = false;
		formAlert: String;
		formTitle: String;
	
		statuses: any;
	
		validationMessages = {
			'compendiumId': [],
			'name': [
				{ type: 'required', message: 'Required' }
			],
			'description': [],
			'status': [],
			'locationType': [],
			'locationArea': [],
			'featureName': [],
			feature: [],
			featureSortOrder: [],
			featureNameSortOrder: [],
			externalUrl: [],
			// 'shortTermRentalId': [],
			// 'developmentId': [],
		};
	
		ngOnInit() {
			this.primengConfig.ripple = true;
			this.formBuild();
			this.fetchProperties();
	
			// if we were passed the whole compendium object
			if (this.compendium) {
				this.compendiumId = this.compendium.compendiumId;
				this.form1.patchValue(this.compendium);
			}
		}
	
		fetchProperties() {
			try {
				this.propertyService.propertySummaryForShortData()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							if (this.compendium) {
								this.compendiumId = this.compendium.compendiumId;
							}
	
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	
		fetchCompendiumShortTermRentalJoinByCompendiumId() {
			try {
				this.compendiumShortTermRentalJoinService.getAllByCompendiumId(this.compendiumId)
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.compendiumShortTermRentalJoins = res.data.compendiumShortTermRentalJoins;
							// this.isDataLoaded = false;
							this.targetProperties = [];
							this.sourceProperties = [];
							
							this.properties.forEach(property => {
								const compendiumHaveProperty = this.compendiumShortTermRentalJoins.find((e: any) => e.shortTermRentalId == property.shortTermRentalId);
								if(compendiumHaveProperty != null) {
									this.targetProperties.push(property);
								}else{
									this.sourceProperties.push(property);
								}
							});
							this.isDataLoaded = true;
							this.primengConfig.ripple = true;
							
							// return this.orderProductShortTermRentalJoins;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	
		fetchCompendiumShortTermRentalJoinByShortTermRentalId(shortTermRental: any) {
			try {
				this.shortTermRentalId = shortTermRental.value;
				this.getAllByCompendiumByShortTermRentalId(shortTermRental.value);
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	
		formBuild() {
			this.form1 = this.formBuilder.group({
				compendiumId: [this.compendiumId],
				name: ['', Validators.required],
				'description': [],
				'status': [],
				'locationType': [],
				'locationArea': [],
				'featureName': [],
				feature: [],
				featureSortOrder: [],
				featureNameSortOrder: [],
				externalUrl: [],
				// shortTermRentalId: [],
				// developmentId: [],
			});
		}
	
		getAllByCompendiumByShortTermRentalId(shortTermRentalId: any) {
		  try {
			this.isSearching = true;
			this.compendiumShortTermRentalJoinService.getAllByCompendiumByShortTermRentalId(shortTermRentalId)
			  .subscribe(
				res => {
					this.isSearching = false;
				  // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
				  this.compendiumShortTermRentalJoinsObj = res.data.compendiumShortTermRentalJoins;
				  this.compendiumShortTermRentalJoinsObj.forEach(compendium => {
					compendium.order = this.getCompendiumOrder(compendium);
				  });
				  this.compendiumShortTermRentalJoinsObj.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
				  this.groupedData = this.groupByOrder(this.compendiumShortTermRentalJoinsObj);
				  this.groupingData = this.groupedData;
				  this.orderByKey = (a: any, b: any): number => {
					return Number(a.key) - Number(b.key);
				  };
				  console.log("Grouped Data:", this.groupingData);
				  this.hasGroupedData = Object.keys(this.groupingData).length > 0;
				  this.isCompendiumLoaded = true;
				},
				err => {
				  console.log('Feature-Update FAIL: ' + JSON.stringify(err));
				  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your compendium: ' + err, sticky: false });
				},
				() => { });
		  } catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
		  }
		}
	
		groupByOrder(compendiumShortTermRentalJoinsObj: any[]) {
		  return compendiumShortTermRentalJoinsObj.reduce((acc, item) => {
			// Check if order group exists, if not create one
			if (!acc[item.order]) {
			  acc[item.order] = [];
			}
			acc[item.order].push(item);
			return acc;
		  }, {} as Record<number, any[]>);
		}
	
		getCompendiumOrder(compendium: any): number {
			if (compendium?.locationArea) {
				const status = this.locationAreas?.find(
					(e: any) => e.value === compendium.locationArea
				);
	
				return status?.order ?? 45; // SAFE FALLBACK
			}
			return 45;
		}
	
	
		getLocationAreaNameCached(key: any): string {
			if (!this.locationAreaNameMap[key]) {
				this.locationAreaNameMap[key] = this.getLocationAreaName(key);
			}
			return this.locationAreaNameMap[key];
		}
	
		getLocationAreaName(key: any): string {
			const area = this.locationAreas?.find(
				(e: any) => e.order == key || e.value == key
			);
			return area?.label || area?.name || '';
		}

	
}
